import React, { useState } from "react";

export default function AppSwitch({
  label,
  description,
  error,
  className = "",
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  invalid = false,
  ...props
}) {
  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  const currentChecked = isControlled ? checked : internalChecked;
  const hasSupportingText = Boolean(description || error);

  function handleChange(event) {
    if (!isControlled) {
      setInternalChecked(event.target.checked);
    }

    if (onChange) {
      onChange(event);
    }
  }

  const classes = [
    "ds-switch-field",
    hasSupportingText ? "" : "ds-switch-field--single-line",
    currentChecked ? "ds-switch-field--checked" : "",
    disabled ? "ds-switch-field--disabled" : "",
    invalid || error ? "ds-switch-field--invalid" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <label className="ds-switch">
        <input
          className="ds-switch__input"
          type="checkbox"
          role="switch"
          checked={Boolean(currentChecked)}
          disabled={disabled}
          aria-invalid={invalid || error ? "true" : undefined}
          onChange={handleChange}
          {...props}
        />
        <span className="ds-switch__control" aria-hidden="true">
          <span className="ds-switch__track">
            <span className="ds-switch__thumb" />
          </span>
        </span>
        {label || description || error ? (
          <span className="ds-switch__content">
            {label ? <span className="ds-switch__label">{label}</span> : null}
            {description && !error ? <span className="ds-switch__description">{description}</span> : null}
            {error ? <span className="ds-switch__error">{error}</span> : null}
          </span>
        ) : null}
      </label>
    </div>
  );
}
